import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateApiKeyComponent } from './create-api-key.component';



@NgModule({
  declarations: [
    CreateApiKeyComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    CreateApiKeyComponent
  ]
})
export class CreateApiKeyModule { }
